let offers;
let product;
let theVariant;
window.selectedOffer = null;
// window.abModalVariant = 11;
function getCurrentlySelectedVariant(product) {
  let selectedVariant = null;
  if(product) {
    selectedVariant = product.variants.find((i) => i.id == mulberryShop.selectedVariantId);
    if (!selectedVariant) {
      selectedVariant = product.variants[0];
    }
    mulberryShop.selectedVariantId = selectedVariant.id;    
  }
  return selectedVariant;
}

async function mulberryPdpInit() {
  const HAS_MODAL = mulberry.core.settings.has_modal || true;
  const HAS_INLINE = mulberry.core.settings.has_inline || true;

  let response = await mulberryShop.getProductData(
    mulberryShop.getProductUrl()
  );
  product = response.product;
  let initSelection = getCurrentlySelectedVariant(product);
  if(initSelection) {
    theVariant = initSelection.id
  }


  let selectedVariant = getCurrentlySelectedVariant(product);
  offers = await mulberry.core.getWarrantyOffer({
    id: selectedVariant.id,
    title: product.title,
    price: selectedVariant.price,
    detail: product,
  });


  if (HAS_INLINE) {
    window.pdpInline = await mulberry.inline.init({
      offers: offers,
      settings: mulberry.core.settings,
      selector: ".mulberry-pdp-inline",
      onWarrantyToggle: async (warranty) => {
        mulberry.inline.isSelected = warranty.isSelected;
        if (warranty.isSelected) {
          window.selectedOffer = warranty;
        } else {
          window.selectedOffer = null;
        }
      },
    });
  }
  
  if (HAS_MODAL) {
    window.pdpModal = await mulberry.modal.init({
      offers: offers,
      settings: mulberry.core.settings,
      onWarrantySelect: async (warranty) => {
        const result = await mulberryShop.getWarrantyVariant(warranty);
        await mulberryShop.addWarrantyToCart(
          result.shopify_variant_id,
          {
            ...product,
            title: product.title,
            variantId: mulberryShop.selectedVariantId,
            quantity: parseInt(document.querySelector('#productQuantity').value)
          },
          warranty
        );
        mulberry.modal.close();
        document?.querySelector("#pdp-atc").removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
      },
      onWarrantyDecline: async () => {
        mulberry.modal.close();
        document?.querySelector("#pdp-atc").removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
      },
    });
  }

  document.addEventListener(
    "variant:change",
    async function (e) {
      window.selectedOffer = null;
      window.pdpModal.updateOffer([]);
      selectedVariant = e.detail.variant;
      offers = await mulberry.core.getWarrantyOffer({
        id: selectedVariant.id,
        title: product.title,
        price: `${(selectedVariant.price/100).toFixed(2)}`,
        detail: product,
      });
      window.pdpModal.updateOffer(offers);
    }
  );
}

document
  ?.querySelector("#pdp-atc")
  ?.addEventListener("click", async function (ev) {
    const handleClick = async () => {
      ev.target.setAttribute('disabled', '');
      const HAS_MODAL = mulberry.core.settings.has_modal || true;
      const HAS_INLINE = mulberry.core.settings.has_inline || true;

      if (HAS_INLINE && window.selectedOffer) {
        await addWarranty();
      }
      else if (HAS_MODAL && window.pdpModal && !window.selectedOffer) {
        window.pdpModal.open();
      }
    };

    await Promise.resolve().then(handleClick);
  });

async function addWarranty() {
  addToCartButtonClicked = true;
  if (!offers || offers.length == 0) {
    return;
  }
  try {
    let result;
    cart = await fetch("/cart.js");
    cartJson = await cart.json();
    if (window.selectedOffer) {
      result = await mulberryShop.getWarrantyVariant(
        window.selectedOffer.offer
      );
      const final = await mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {
          ...product,
          title: product.title,
          variantId: mulberryShop.selectedVariantId,
          quantity: parseInt(document.querySelector('#productQuantity').value)
        },
        window.selectedOffer.offer
      );
      document?.querySelector("#pdp-atc").removeAttribute('disabled');
      window.selectedOffer = null;
      window.pdpInline.deselectOffer();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
    }
  } catch (err) {
    console.log("mulberry error: ", err);
  }
}

document.addEventListener("mulberry-shopify:loaded", async function (e) {
  window.mb_gtm_is_disabled = true
  setupFetchListeners();
  await removeAndSyncWarranties();
  if (window.location.pathname.indexOf("/products/espresso-series-1") >= 0)  {
    mulberryPdpInit();

    function getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
    
    async function handleUrlChange() {
      var variant = getUrlParameter('variant');
      if (variant && theVariant !== variant) {
        theVariant = variant
        window.selectedOffer = null;
        mulberryShop.selectedVariantId = variant
        selectedVariant = getCurrentlySelectedVariant(product);

        if(selectedVariant) {
          offers = await mulberry.core.getWarrantyOffer({
            id: selectedVariant.id,
            title: product.title,
            price: selectedVariant.price,
            detail: product,
          });
          window.pdpModal.updateOffer(offers);
        }
      }
    }

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
          handleUrlChange();
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['href']
    });
 
    ['click', 'touchstart'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (e.target.closest('.radio-group__color')) {
          setTimeout(() => {
            handleUrlChange();
          }, 100)
        }
      }, { passive: true });
    });
    
    handleUrlChange();    
  }
  await mulberryShop.cart.init();
  mulberryShop.cart.render();
});

async function removeAndSyncWarranties(reload = false) {
  let response = await fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  let firstCart = await response.json();
  const originalItemCount = firstCart.item_count;

  // Filter items
  firstCart.items = firstCart.items.filter(
    item => item?.properties?._variantId !== 'sectional'
  );

  try {
    const newCart = await mulberryShop.removeDetachedWarranty(firstCart);
    const updatedCart = await mulberryShop.cart.syncQuantities(newCart);

  } catch (error) {
    console.error('Error during warranty removal and cart sync:', error);
  }
}


function setupFetchListeners() {
  const { fetch: origFetch } = window;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    let requestUrl = args[0];
    if (typeof requestUrl === 'string') {
      requestUrl = requestUrl.toString();
      if (requestUrl.includes("cart/change")) {
        response
          .clone()
          .json()
          .then(async (body) => {
            await removeAndSyncWarranties();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
          })
          .catch((err) => console.error(err));
      }
    }
    return response;
  };
}